export class PartnerTermsData {
  landingPage: string;
  landingPageUrl: string;
  cusCareNumber: string;
  isPartner: boolean;
}
